import { IStandardDocumentVersionData } from '../../../types/order/documents/shared/interfaces';
import React, { useState } from 'react';
import { DataGrid, Grid, Header2Text } from '../../../ui-toolkit';
import { PDFPreview } from '../../../ui-toolkit/components/PDFPreview';
import { UUID } from '../../../types/shared/UUID';
import { clientDocumentSorting } from '../../../utilities/clientPortal/documentSorting';
import { generateClientColumns } from '../../../utilities/clientPortal/documentsTableColumns';
import { IDocumentCategory } from '../../../types/order/documents/IDocumentCategoryType';
import { createDownloadDocumentUrl } from '../../../API/order/documents/adminDocumentsAPI';

export const DocumentsTable: React.FC<{
  documents: IStandardDocumentVersionData[];
  orderId: UUID;
  documentCategoriesByName: Record<string, IDocumentCategory>;
}> = ({ documents, orderId, documentCategoriesByName }) => {
  const [previewDoc, setPreviewDoc] = useState<IStandardDocumentVersionData | null>(null);
  const presentationDocs = clientDocumentSorting(documents, documentCategoriesByName);

  return (
    <Grid>
      <Grid>
        <Header2Text>Documents</Header2Text>
      </Grid>
      <DataGrid
        columns={generateClientColumns({
          setPreviewDoc,
          orderId,
          documentCategoriesByName,
        })}
        data={presentationDocs}
        defaultSorted={[{ dataField: 'updatedAt', order: 'desc' }]}
        keyField={'id'}
      />
      {previewDoc && (
        <PDFPreview
          file={createDownloadDocumentUrl(previewDoc.id, previewDoc.versionId)}
          onClose={() => setPreviewDoc(null)}
        />
      )}
    </Grid>
  );
};
